import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

const Philosophy = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="philosophy-section"
      className="relative bg-white py-24 md:py-36 border-t border-[#E4E7ED]"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 md:mb-20">
          <div className="lg:col-span-8">
            <p className="text-[11px] tracking-[0.35em] uppercase text-[#6F2DBD] font-semibold mb-6 flex items-center gap-3">
              <span className="inline-block w-10 h-px bg-[#6F2DBD]" />
              {t.philosophy.overline}
            </p>
            <h2 className="font-display text-[#002B6B] text-4xl md:text-5xl lg:text-6xl leading-[1.02] uppercase">
              {t.philosophy.title}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          {t.philosophy.items.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`philosophy-${i}`}
              className="border-t-2 border-[#002B6B] pt-6"
            >
              <span className="text-[11px] tracking-[0.3em] uppercase text-[#6F2DBD] font-bold">
                0{i + 1}
              </span>
              <h4 className="font-display text-2xl md:text-3xl text-[#002B6B] mt-3 uppercase">
                {p.title}
              </h4>
              <p className="mt-4 text-sm text-[#6B7280] font-editorial font-light leading-relaxed">
                {p.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
